<template>
  <div @click="$emit('click')" role="cell" :is="tag" :class="['bcq-table-layout-cell', fullWidth ? 'bcq-table-layout-cell-full-width' : null, xAlign ? `bcq-table-layout-cell-x-align-${xAlign}` : null, yAlign ? `bcq-table-layout-cell-v-align-${yAlign}` : null]">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Cell',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    xAlign: {
      type: String,
      validator: value => {
        return ['left', 'center', 'right', 'auto', 'justify'].includes(value)
      }
    },
    yAlign: {
      type: String,
      default: 'top',
      validator: value => {
        return ['top', 'middle', 'bottom', 'baseline', 'auto'].includes(value)
      }
    },
    fullWidth: {
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/cell/cell.vue